import React from 'react'
import BlockLogoCarousel from '@berlitz/blocks/lib/BlockLogoCarousel'
import { getSerializedHTML, getBackgroundColor } from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'

const SliceLogoCarousel = ({ primary, items, pageLinks }) => {
  const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
  const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
  return (
    <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}>
        <BlockLogoCarousel
          title={primary.logo_carousel_title}
          subtitle={
            primary.logo_carousel_subtitle?.html ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: getSerializedHTML(
                    primary.logo_carousel_subtitle.richText,
                    pageLinks
                  ),
                }}
              />
            ) : null
          }
          backgroundColor={getBackgroundColor(primary.section_background_color)}
          images={items.map(item => ({ src: item.logo.url }))}
        />
    </SliceWrapper>
  )
}

export default SliceLogoCarousel
